<template>
  <div class="mx-auto my-12 flex w-full items-end justify-center">
    <RevInputText
      id="copy-clipboard-input"
      class="mr-3 w-full"
      :label="inputLabel"
      :model-value="value"
    />
    <RevButton variant="primary" @click="handleClick">
      {{ buttonLabel }}
    </RevButton>
  </div>
</template>

<script lang="ts" setup>
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevButton } from '@ds/components/Button'
import { RevInputText } from '@ds/components/InputText'

import { copyToClipboard } from './CopyClipBoard.helper'

export type CopyClipBoardProps = {
  value: string
  valueToCopy?: string
  name: string
  zone: string
  inputLabel: string
  buttonLabel: string
  toastContent: {
    title: string
    text: string
  }
  toastStyle?: {
    variant: 'success' | 'error' | 'info'
    iconSrc: string
  }
}

const props = withDefaults(defineProps<CopyClipBoardProps>(), {
  valueToCopy: '',
  toastStyle: () => ({
    variant: 'success',
    iconSrc: '/img/toast/rabbit.svg',
  }),
})

const tracking = useTracking()
const { openSuccessToast } = useTheToast()

const handleClick = () => {
  const value = !isEmpty(props.valueToCopy) ? props.valueToCopy : props.value

  if (copyToClipboard(value)) {
    openSuccessToast({
      title: props.toastContent.title,
      content: props.toastContent.text,
      name: 'TOAST_COPY_CLIPBOARD',
    })

    tracking.trackClick({
      name: props.name,
      zone: props.zone,
      value: props.value,
    })
  }
}
</script>
